import cn from 'classnames';
import React from 'react';

import { Icon } from '@sravni/react-design-system/lib/Icon';
import { Text } from '@sravni/react-design-system/lib/Typography';
import { Tip } from '@sravni/react-icons';
import { useBoolean } from '@sravni/react-utils';

import styles from './MobileAppConvenienceBanner.module.scss';
import { MobileAppConvenienceBannerTexts } from './MobileAppConvenienceBanner.texts';
import { MobileAppConvenienceSheet } from './MobileAppConvenienceSheet';

interface Props {
  amount: number;
  term: number;
  isLandingPage: boolean;
  variant?: 'light' | 'dark';
  isUserFromGoogleSearch: boolean;
}

export const MobileAppConvenienceBanner = ({
  amount,
  term,
  isLandingPage,
  variant = 'light',
  isUserFromGoogleSearch,
}: Props) => {
  const [isSheetVisible, setIsSheetVisible] = useBoolean();

  return (
    <>
      <div className={cn(styles.banner, { [styles.bannerDark]: variant === 'dark' })}>
        <Text size={14} className={styles.text}>
          {MobileAppConvenienceBannerTexts.title}
        </Text>
        <Icon className={styles.icon} size={16} icon={<Tip />} onClick={setIsSheetVisible.on} />
      </div>

      <MobileAppConvenienceSheet
        amount={amount}
        term={term}
        visible={isSheetVisible}
        onClose={setIsSheetVisible.off}
        isLandingPage={isLandingPage}
        isUserFromGoogleSearch={isUserFromGoogleSearch}
      />
    </>
  );
};
